/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SettingsState = zod
	.object({
		auto_recharge_effective: zod
			.boolean()
			.describe('Whether auto-recharge is active on the billing provider'),
		auto_recharge_enabled: zod.boolean().describe('Auto-recharge enabled'),
		auto_recharge_target_usd: zod.string().nullable().describe('Auto-recharge target'),
		auto_recharge_threshold_usd: zod.string().nullable().describe('Auto-recharge threshold'),
		hard_limit_usd: zod.string().nullable().describe('Hard spending limit'),
		soft_limit_usd: zod.string().nullable().describe('Soft spending limit')
	})
	.describe('Billing settings');

export type SettingsState = zod.input<typeof SettingsState>;
export type SettingsStateOutput = zod.output<typeof SettingsState>;
